import { StatusTagDisplay } from "commonComponents/utilities/Status/StatusTagDisplay";

export const ArchivedUserTagDisplay: React.FunctionComponent = () => {
    return (
        <StatusTagDisplay className="ArchivedUserTag" statusType="" statusText="Archived" useBds />
    );
};
